/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { ClosedEnum } from "../../types/enums.js";
import {
  LogFilter,
  LogFilter$Outbound,
  LogFilter$outboundSchema,
} from "./logfilter.js";
import {
  SearchLogsFilter,
  SearchLogsFilter$Outbound,
  SearchLogsFilter$outboundSchema,
} from "./searchlogsfilter.js";

/**
 * Sort order
 */
export const SearchLogsPayloadSort = {
  Asc: "asc",
  Desc: "desc",
} as const;
/**
 * Sort order
 */
export type SearchLogsPayloadSort = ClosedEnum<typeof SearchLogsPayloadSort>;

/**
 * Payload for searching telemetry logs
 */
export type SearchLogsPayload = {
  /**
   * Cursor for pagination
   */
  cursor?: string | undefined;
  /**
   * Filter criteria for searching logs
   */
  filter?: SearchLogsFilter | undefined;
  /**
   * Filter conditions for the search query
   */
  filters?: Array<LogFilter> | undefined;
  /**
   * Start time in ISO 8601 format (e.g., '2025-12-19T10:00:00Z')
   */
  from?: Date | undefined;
  /**
   * Number of items to return (1-1000)
   */
  limit?: number | undefined;
  /**
   * Sort order
   */
  sort?: SearchLogsPayloadSort | undefined;
  /**
   * End time in ISO 8601 format (e.g., '2025-12-19T11:00:00Z')
   */
  to?: Date | undefined;
};

/** @internal */
export const SearchLogsPayloadSort$outboundSchema: z.ZodMiniEnum<
  typeof SearchLogsPayloadSort
> = z.enum(SearchLogsPayloadSort);

/** @internal */
export type SearchLogsPayload$Outbound = {
  cursor?: string | undefined;
  filter?: SearchLogsFilter$Outbound | undefined;
  filters?: Array<LogFilter$Outbound> | undefined;
  from?: string | undefined;
  limit: number;
  sort: string;
  to?: string | undefined;
};

/** @internal */
export const SearchLogsPayload$outboundSchema: z.ZodMiniType<
  SearchLogsPayload$Outbound,
  SearchLogsPayload
> = z.object({
  cursor: z.optional(z.string()),
  filter: z.optional(SearchLogsFilter$outboundSchema),
  filters: z.optional(z.array(LogFilter$outboundSchema)),
  from: z.optional(z.pipe(z.date(), z.transform(v => v.toISOString()))),
  limit: z._default(z.int(), 50),
  sort: z._default(SearchLogsPayloadSort$outboundSchema, "desc"),
  to: z.optional(z.pipe(z.date(), z.transform(v => v.toISOString()))),
});

export function searchLogsPayloadToJSON(
  searchLogsPayload: SearchLogsPayload,
): string {
  return JSON.stringify(
    SearchLogsPayload$outboundSchema.parse(searchLogsPayload),
  );
}
